'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformCalcElements = exports.transformFunctionElements = exports.decorateWithData = exports.transformValues = exports.transformValue = exports.prepareForTransform = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _regexp = require('../const/regexp');

var _formatting = require('./formatting');

var _predicate = require('./predicate');

var _templates = require('./templates');

var transformArgumentParts = function transformArgumentParts(transform) {
  return (0, _ramda.map)((0, _ramda.pipe)(_ramda.trim, _formatting.splitOnWhitespace, (0, _ramda.map)((0, _ramda.pipe)(_ramdaAdjunct.ensureArray, transform)), _formatting.joinWithSpace));
};

var transformFunctionArguments = function transformFunctionArguments(transform) {
  return (0, _ramda.pipe)(_formatting.splitOnUnnestedComma, transformArgumentParts(transform), _formatting.joinWithCommaSpace);
};

var prepareForTransform = exports.prepareForTransform = (0, _ramda.pipe)((0, _ramda.when)(_predicate.isNotStringOrArray, String), (0, _ramda.when)(_ramdaAdjunct.isString, _formatting.splitOnUnnestedWhitespace));

var transformValue = exports.transformValue = (0, _ramda.curry)(function (transformers, value, data, breakpointName) {
  return (0, _ramda.reduce)(function (currentValue, transformer) {
    return transformer(currentValue, data, breakpointName);
  }, value, (0, _ramda.pipe)(_ramdaAdjunct.ensureArray, _ramda.flatten)(transformers));
});

var transformValues = exports.transformValues = function transformValues(transformers, values, data, breakpointName) {
  return (0, _ramda.map)(function (value) {
    return transformValue(transformers, value, data, breakpointName);
  }, values);
};
var decorateWithData = exports.decorateWithData = function decorateWithData(predicateTransformers, data, breakpointName) {
  return (0, _ramda.map)(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        predicate = _ref2[0],
        transformers = _ref2[1];

    return [predicate, function (value) {
      return transformValue(transformers, value, data, breakpointName);
    }];
  })(predicateTransformers);
};

var transformFunctionElements = exports.transformFunctionElements = function transformFunctionElements(transform) {
  return function (value) {
    var typeOfFunction = (0, _ramda.match)(_regexp.RE_CSS_FUNCTION_NAME, value)[1];
    return (0, _ramda.pipe)(_ramda.trim, _formatting.extractFunctionArguments, transformFunctionArguments(transform), function (v) {
      return (0, _templates.createCSSFunctionFromTemplate)({ typeOfFunction: typeOfFunction, value: v });
    })(value);
  };
};

var transformCalcElements = exports.transformCalcElements = function transformCalcElements(transform) {
  return function (value) {
    return (0, _ramda.pipe)(_ramda.trim, _formatting.extractFunctionArguments, (0, _ramda.replace)(_regexp.RE_CALC_VALUES, function (v) {
      var r = transform(v);
      return r;
    }), function (v) {
      return (0, _templates.createCSSFunctionFromTemplate)({ typeOfFunction: 'calc', value: v });
    })(value);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/transformers.js
// module id = 29
// module chunks = 168707334958949